module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external "ecCom"
// module id = 15
// module chunks = 24